module.exports = __webpack_public_path__ + "img/logo1080119.ecd5e23a.png";